const LOCATIONS = {
  ACCOUNT_LOGIN: '/auth/login/',
  ACCOUNT_PASSWORD_UPDATE: '/user/account/profile/update-password/',
};

export default LOCATIONS;